import { TeamsResponse, createTeamsPayload, updateTeamsPayload } from '../features/applicationQuestionnaire/applicationQuestionnaireTypes';
import { del, get, post, put } from '../utils/api';
import { formatUrl } from '../utils/urlFormatter';


const fetch_locations = '/{0}/scorecard.list';
const create_locations = '/{0}/scorecard.add';
const update_location = '/{0}/{1}/scorecard.update';
const fetch_locations_status = '/{0}/scorecard.list';
const fetch_pipeline_details = '/{0}/{1}/scorecard.detail';
const fetch_score_card_pipeline_details = '/{0}/{1}/scorecard.listByJob';
const assign_scorecard_pipeline = '/{0}/{1}/{2}/scorecard.assignJob';
const delete_app_scorecard = '/{0}/{1}/appScorecard.deleteAppScorecard';


// score card 
const fetch_application_questionnaire_list = '/{0}/{1}/app_QuestionSet.list';
const fetch_application_questionnaire_details = '/{0}/{1}/app_QuestionSet.answers';
const update_application_questionnaire_details = '/{0}/{1}/app_QuestionSet.update';



const credentialsConfig = {
    withCredentials: true,
}


export const fetchLocationData = async (baseId: number): Promise<TeamsResponse> => {
    const fetch_location_data = formatUrl(fetch_locations, [baseId]);
    return get<TeamsResponse>(fetch_location_data, credentialsConfig);
};

export const fetchLocationDataStatus = async (baseId: number, status?: string): Promise<TeamsResponse> => {
    let fetch_location_data = formatUrl(fetch_locations_status, [baseId]);
    if (status) {
        fetch_location_data += `?status=${status}`;
    }
    return get<TeamsResponse>(fetch_location_data, credentialsConfig);
};


export const createLoationData = async (data: createTeamsPayload, userId: number): Promise<TeamsResponse> => {
    const base_create_location = formatUrl(create_locations, [userId]);
    return post<TeamsResponse>(base_create_location, data, credentialsConfig);
};


export const updateLocationData = async (id: number, baseId: number, data: updateTeamsPayload): Promise<TeamsResponse> => {
    const update_teams_data = formatUrl(update_location, [id, baseId]);
    return put<TeamsResponse>(update_teams_data, data, credentialsConfig);
};

export const fetchPipelineDetails = async (baseId: number, userId: string): Promise<TeamsResponse> => {
    const fetch_pipeline_details1 = formatUrl(fetch_pipeline_details, [baseId, userId]);
    return get<TeamsResponse>(fetch_pipeline_details1, credentialsConfig);
};

export const fetchScoreCardPipelineDetails = async (baseId: number, JobId: string): Promise<TeamsResponse> => {
    const fetch_job_pipeline_details1 = formatUrl(fetch_score_card_pipeline_details, [baseId, JobId]);
    return get<TeamsResponse>(fetch_job_pipeline_details1, credentialsConfig);
};

export const assignScoreCardPipelineDetails = async (baseId: number,userId: string, JobId: string): Promise<TeamsResponse> => {
    const assign_job_pipeline_details1 = formatUrl(assign_scorecard_pipeline, [baseId,userId, JobId]);
    return post<TeamsResponse>(assign_job_pipeline_details1, {}, credentialsConfig);
};

export const deleteAppScorecardData = async (baseId: number, id: number): Promise<TeamsResponse> => {
  const formattedUrl = formatUrl(delete_app_scorecard, [baseId, id]);
  return del<TeamsResponse>(formattedUrl, credentialsConfig);
};


// score card 

export const fetchApplicationQuestionnaireByList = async (
  baseId: number,
  appId: number,
  // stageId: string,
  page: number = 1,
  limit: number = 25,
  filters: any = {}
): Promise<TeamsResponse> => {
  const endpoint = formatUrl(fetch_application_questionnaire_list, [baseId, appId]);

  const queryParamsObj: { [key: string]: string } = {
    page: page.toString(),
    limit: limit.toString(),
  };

  // Add search if present
  if (filters.search) {
    queryParamsObj.search = filters.search;
  }

  const queryParams = new URLSearchParams(queryParamsObj).toString();

  return get<TeamsResponse>(`${endpoint}?${queryParams}`, credentialsConfig);
};


export const fetchApplicationQuestionSetAnswerData = async (baseId: number, questionnaireId: string): Promise<TeamsResponse> => {
  const fetch_location_data = formatUrl(fetch_application_questionnaire_details, [baseId, questionnaireId]);
  return get<TeamsResponse>(fetch_location_data, credentialsConfig);
};

export const updateApplicationQuestionSetAnswerData = async (
  baseId: number,
  questionnaireId: string,
  data: any
): Promise<TeamsResponse> => {
  const update_location_data = formatUrl(update_application_questionnaire_details, [baseId, questionnaireId]);
  return put<TeamsResponse>(update_location_data, data, credentialsConfig);
};